import { IApiBaseResponse } from '~/utils/interface/common';
import axiosClient from './axiosClient';
import { IBodyCreatePriceItem, IPriceItem } from '~/utils/interface/priceItem';
import {
  IParamsGetPriceComponent,
  IPayloadDeletePriceComponent,
  IResponseGetPriceList,
} from '~/utils/interface/estimate';

const url = `api/admin/price-items`;
const priceItemApi = {
  createPriceItem(data: IBodyCreatePriceItem) {
    return axiosClient.post<IApiBaseResponse<IPriceItem>>(url, data);
  },
  getPriceListItem(params: IParamsGetPriceComponent) {
    return axiosClient.get<IApiBaseResponse<IResponseGetPriceList>>(url, { params });
  },
  getPriceItem(id: string) {
    return axiosClient.get<IApiBaseResponse<IPriceItem>>(`api/admin/price-items/${id}`);
  },
  deletePriceItem(data: IPayloadDeletePriceComponent) {
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },
  updatePriceItem(id: string, data: IBodyCreatePriceItem) {
    return axiosClient.put<IApiBaseResponse<IPriceItem>>(`api/admin/price-items/${id}`, data);
  },
};

export default priceItemApi;
